import React from "react";

import SignInContainer from "../components/business/SignInContainer/SignInContainer";

const SignInPage = () => {
  return <SignInContainer />;
};

export default SignInPage;
